import { PersistConfig } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { TeamsSlice } from '../store/types';

type TeamsPersistConfig = PersistConfig<TeamsSlice>;

export const teamsPersistConfig: TeamsPersistConfig = {
  key: 'teams',
  storage,
};
